export const WPAPIEndpoint: string = homeURL + '/wp-json/wp/v2';
export const afMenus: Record<string, any> = {};